"use client";

import Link from "next/link";
import { Bell } from "lucide-react";
import { usePathname, useRouter } from "next/navigation";
import useInboxNotifications from "@/hooks/useInboxNotifications";

export default function NotificationBell() {
  const { unreadCount, user } = useInboxNotifications();
  const pathname = usePathname();
  const router = useRouter();
  const isNotificationsPage = pathname === "/notifications";

  if (!user) return null;

  return (
    <Link
      href="/notifications"
      onClick={(event) => {
        if (!isNotificationsPage) return;
        event.preventDefault();
        router.back();
      }}
      aria-label={unreadCount ? `Notifications, ${unreadCount} unread` : "Notifications"}
      aria-current={isNotificationsPage ? "page" : undefined}
      className={`btn-halo-icon relative inline-flex items-center gap-2 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--card)] ${
        isNotificationsPage ? "text-[var(--brand)]" : ""
      }`}
    >
      <span className="icon-halo"><Bell size={18} aria-hidden className={isNotificationsPage ? "fill-current" : ""} /></span>
      {unreadCount > 0 ? (
        <span className="badge-pop absolute -right-1 -top-1 min-w-[1.25rem] rounded-full bg-[var(--brand)] px-1 text-center text-[10px] font-bold text-white">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      ) : null}
    </Link>
  );
}
